module.exports = __webpack_public_path__ + "img/noti-thumb-1.9c7577bb.png";